import React from "react";
import { HeaderComponent,BackgroundImage,VideoPlayer } from "../../FifthComponents";

const Testimonials = (props) => {
    const { selectedLanguage } = props;
    return (
        <div>
            <BackgroundImage screenName={selectedLanguage?.txt_testimonials} classForBg='fifth-des-testimonials-bg' {...props}/>
            <HeaderComponent title={selectedLanguage?.txt_testimonials} lineClass='bg-gray' titleClass='color-blue' />
            <div className="fifth-testimonial-video-player">
                <VideoPlayer videoUrl='https://www.youtube.com/embed/phvAW5rIP_Y'/>
            </div>
            <div className="fifth-testimonial-video-player testimonial-video-screen-div">
                <VideoPlayer videoUrl='https://www.youtube.com/embed/KvOmjhP2Msk'/>
            </div>
            <div className="fifth-testimonial-video-player testimonial-video-screen-div testimonial-last-video-screen-div">
                <VideoPlayer videoUrl='https://www.youtube.com/embed/aIi2plN6lvo'/>
            </div>
        </div>
    )
}
export default Testimonials
